import React, { useState, useRef, useEffect } from "react";
import { Stage, Layer, Line, Circle } from "react-konva";

export default function PolygonDrawer({
  points,
  setPoints,
  isPolygoneComplete,
  setIsPolygoneComplete,
  activeTabIndex,
  setIsPolygoneStage,
  setMultiplePolygone,
  setUpdatedMultiplePolygone
}) {
  const containerRef = useRef(null);
  const [stageSize, setStageSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const resize = () => {
      if (containerRef.current) {
        const { clientWidth, clientHeight } = containerRef.current;
        setStageSize({
          width: clientWidth,
          height: clientHeight - 2,
        });
      }
    };

    resize();
    const observer = new ResizeObserver(resize);
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  const handleStageClick = (e) => {
    if (isPolygoneComplete) return;
    const stage = e.target.getStage();
    const mousePos = stage.getPointerPosition();
    setPoints([...points, mousePos.x, mousePos.y]);
  };

  const handleCompletePolygon = () => {
    if (points.length < 6) return;

    const getBoundingBox = (pts) => {
      const xs = pts.filter((_, i) => i % 2 === 0);
      const ys = pts.filter((_, i) => i % 2 === 1);
      const minX = Math.min(...xs);
      const maxX = Math.max(...xs);
      const minY = Math.min(...ys);
      const maxY = Math.max(...ys);
      return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY,
      };
    };

    const bounds = getBoundingBox(points);
    const relativePoints = points.map((val, i) =>
      i % 2 === 0 ? val - bounds.x : val - bounds.y
    );

    const newPolygone = {
      deviceName: "Polygone",
      type: "Polygone",
      points: relativePoints,
      bgColor: "rgba(0, 0, 255, 0.3)",
      width: bounds.width,
      height: bounds.height,
      tabIndex: activeTabIndex,
      x: bounds.x,
      y: bounds.y,
      strokeColor: "blue",
    };

    const newUpdatedPolygone = {
      deviceName: "Polygone",
      type: "Polygone",
      points: relativePoints,
      bgColor: "rgba(0, 0, 255, 0.3)",
      width: bounds.width,
      height: bounds.height,
      tabIndex: activeTabIndex,
      x: bounds.x,
      y: bounds.y,
      strokeColor: "blue",
    };

    setMultiplePolygone((prev) => [...prev, newPolygone]);
    setUpdatedMultiplePolygone((prev) => [...prev, newUpdatedPolygone]);

    setIsPolygoneComplete(true);
    setIsPolygoneStage(false);
    setPoints([]);
  };

  const handlePolygoneReset = () => {
    setPoints([]);
    setIsPolygoneComplete(false);
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        paddingBottom: "0.5rem",
        position: "absolute",
        zIndex: "100",
      }}
    >
      <div
        style={{
          position: "fixed",
          bottom: "2%",
          left: "40%",
          display: "flex",
          gap: ".5rem",
        }}
      >
        <button
          onClick={handleCompletePolygon}
          disabled={isPolygoneComplete || points.length < 6}
          style={{
            backgroundColor: "#2d5bff",
            padding: ".3rem .5rem",
            color: "#ffffff",
            borderRadius: ".5rem",
            border: "none",
          }}
        >
          Complete Polygon
        </button>
        <button
          onClick={handlePolygoneReset}
          style={{
            backgroundColor: "#2d5bff",
            padding: "0.3rem 0.5rem",
            color: "#ffffff",
            borderRadius: ".5rem",
            border: "none",
          }}
        >
          Reset
        </button>
      </div>

      <div
        ref={containerRef}
        style={{ flex: 1, width: "100%", position: "relative" }}
      >
        <Stage
          width={stageSize.width}
          height={stageSize.height}
          onClick={handleStageClick}
        >
          <Layer>
            {points.length > 0 && (
              <Line
                points={points}
                closed={isPolygoneComplete}
                stroke="blue"
                strokeWidth={2}
                fill={isPolygoneComplete ? "rgba(0, 0, 255, 0.3)" : ""}
              />
            )}
            {points.map((_, i) =>
              i % 2 === 0 ? (
                <Circle
                  key={i}
                  x={points[i]}
                  y={points[i + 1]}
                  radius={4}
                  fill="red"
                />
              ) : null
            )}
          </Layer>
        </Stage>
      </div>
    </div>
  );
}
